<template>
  <div class="activity-details activity-flex-box">
    <header class="activity-header-info">
      <div class="activity-time">
        有效期：{{ details.beginTime }}至{{ details.endTime }}
      </div>
      <div class="activity-title">{{ details.title }}</div>
      <div class="activity-text"></div>
    </header>
    <div class="details-block-6">
      <section class="activity-content">
        <div class="activity-icon">活动类型</div>
        <div
          class="text"
          v-if="details.couponAmounts && details.couponAmounts[0]"
        >
          <div v-for="(item, index) in details.couponAmounts" :key="index">
            <template
              v-if="
                item.releaseConditions &&
                  item.releaseConditions[0].releaseType == 6
              "
            >
              <!-- 累计 -->
              <div>
                1、成功邀请{{ item.releaseConditions[0].base }}位好友，将获得
                <span v-for="(child, i) in item.templates" :key="i">
                  满{{ child.discount.condition }}减{{
                    child.discount.discount
                  }}优惠券{{ child.releaseNumber }}张;
                </span>
              </div>
            </template>
            <template
              v-if="
                item.releaseConditions &&
                  item.releaseConditions[0].releaseType == 5
              "
            >
              成功邀请{{ item.releaseConditions[0].base }}好友注册成功，
              <template v-if="item.releaseConditions[0].cumulativeValue > 0">
                并在{{
                  item.releaseConditions[0].cumulativeDuration
                }}天内充电达{{ item.releaseConditions[0].cumulativeValue }}度，
              </template>
              将获得
              <span v-for="(child, i) in item.templates" :key="i">
                满{{ child.discount.condition }}减{{
                  child.discount.discount
                }}优惠券{{ child.releaseNumber }}张;
              </span>
            </template>
          </div>
        </div>
      </section>
    </div>
    <div class="details-btn">
      <pi-button type="primary" block @click="goQrcode">二维码邀请</pi-button>
      <pi-button type="primary" block @click="goLink">通过链接邀请</pi-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pi-activity-6',
  props : {
    details:{
      type: Object,
      default:()=>{
        return {}
      }
    }
  },
  data(){
    return {

    }
  },
  methods: {
    goQrcode(){
      this.$router.push('/qrcode-invite');
    },
    goLink(){
      this.$router.push('/link-invite')
    }
  },
}
</script>
<style lang="less">
.activity-details.activity-flex-box{
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 100%;
  .activity-content{
    padding-left: 0;
    padding-right: 0;
    .text{
      margin-top: 0.34rem;
    }
  }
  .activity-content:first-child{
    margin-top: 0.42rem;
  }
}
  .activity-details{
    
    .details-block-6{
      padding: 0.5rem 0.4rem;
      flex: 1;
      .title-bg{
        background-image: url('../../../assets/image/activity-title.png');
        background-size: 100% 100%;
        width: 3.73rem;
        height: 0.84rem;
        font-size: 0.36rem;
        line-height: 0.54rem;
        margin: auto;
      }
    }
    .details-btn{
      padding: 0.2rem 0.4rem;
      .pi-button{
        margin-bottom: 0.2rem;
      }
    }
  }
</style>